import { createSelector } from '@ngrx/store';
import { AdobeLaunchState } from '@store/reducers/adobe-launch/adobe-launch.reducer';

import * as fromAdobeLaunch from '../../reducers/adobe-launch/adobe-launch.reducer';
import * as fromFeature from '../../reducers/index';

export const selectAdobeLaunch = createSelector(
  fromFeature.getAdobeLaunchState,
  (state: AdobeLaunchState) => state,
);
export const selectTrackProcessStartCalled = createSelector(
  selectAdobeLaunch,
  fromAdobeLaunch.getTrackProcessStartCalled,
);
